module.exports = __webpack_public_path__ + "a19bc3f2ac861886027075d9dfddcc47.ttf";